<template>
  <div class="fee-settings-particulars">
     
      <h1 class="text-left mx-4 mt-2">Fee Structure</h1>
      <h5 class="text-left mx-4">{{ activeFeeSession.title }}</h5>
      <h2 class="text--secondary text-left mx-4">Categories</h2>

      <v-row>
        <v-col cols="12">
          <h2 v-if="!categories.length && !isLoading">No Fee Categories Found.</h2>
        </v-col>
        <v-col cols="12" md="4" v-for="category in categories" :key="category.id">
          <v-card class="mx-4 my-2" :to="{'name': 'FeeSettingsStructureCategoryDetails', params: {rid: $route.params.rid, cid: category.id}}">
            <v-card-title class="pb-0 text--secondary">
              <h4>{{ category.code }}</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-0">
              <v-row>
                <v-col class="pb-0" cols="6">
                  <p class="text--secondary text-left mb-0">Total Fees</p>
                </v-col>
                <v-col class="pb-0" cols="6">   
                  <b class="black--text">{{ currency_format(category.total_fees) }}</b>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
     
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
export default {
  name: "FeeSettingsParticulars",
  data() {
    return {
      categories: [],

      snackbar: {
        visible: false,
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading","activeFeeSession"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    currency_format(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "INR",
      });
      return formatter.format(amount);
    },

    async getAllRoomCategories() {
      var response;
      var url = endpoints.getAllRoomCategories + this.$route.params.rid + `/?session=${this.activeFeeSession.id}`;       
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        this.categories = response;
      }
    },
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.message = "Unable to process request";
        this.snackbar.visible = true;
      }
    },
  },
  async created() {
    this.getAllRoomCategories();
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>